import { render, staticRenderFns } from "./AtividadeCrianca.vue?vue&type=template&id=4e533350"
import script from "./AtividadeCrianca.vue?vue&type=script&lang=js"
export * from "./AtividadeCrianca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports